import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flowObjectTypeId", "triggerContent", "layout"];
import { OZ } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import ObjectTypeIcons, { DEFAULT_ICON } from 'automation-ui-action-features/constants/ObjectTypeIcons';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import ActionDetailsButton from 'automation-ui-action-features/action-details/ActionDetailsButton';
import DetailsPopoverContent from 'automation-ui-action-features/action-details/DetailsPopoverContent';
import DetailsPopoverSection from 'automation-ui-action-features/action-details/DetailsPopoverSection';
import * as SpecialActionIds from 'automation-ui-flow-core/canvas/SpecialActionIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SimpleEnrollmentCard = _ref => {
  let {
      flowObjectTypeId,
      triggerContent = null,
      layout
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const icon = ObjectTypeIcons[flowObjectTypeId] || DEFAULT_ICON;
  const title = /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
    baseLangKey: "enrollment.canvas.header_cob",
    objectTypeId: flowObjectTypeId
  });
  const content = /*#__PURE__*/_jsx(SanitizedText, {
    body: triggerContent
  });
  const ActionDetailsButtonContent = () => /*#__PURE__*/_jsx(DetailsPopoverContent, {
    headerIconName: icon,
    headerTitle: title,
    theme: "default",
    statusIcon: "success",
    statusColor: OZ,
    statusText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "enrollment.canvas.popover.status"
    }),
    children: /*#__PURE__*/_jsx(DetailsPopoverSection, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrollment.canvas.popover.explainerHeading"
      }),
      children: content
    })
  });
  function TitleAction() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx(ActionDetailsButton, {
        use: layout === 'zoomed-out' ? 'icon' : 'link',
        trackingIdentifier: SpecialActionIds.ENROLLMENT,
        Content: ActionDetailsButtonContent
      })]
    });
  }
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    "data-test-id": "simple-enrollment-action",
    clickable: false,
    content: content,
    headerIcon: icon,
    headerTitle: title,
    titleUseTheme: "default",
    TitleAction: TitleAction,
    layout: layout
  }));
};
export default SimpleEnrollmentCard;